import React, { useEffect, useRef, useState } from 'react';
import { Container as MapDiv, NaverMap, Marker, useNavermaps } from 'react-naver-maps';

const DrillLogMapPreview = ({ boreholes, onBoreholeClick }) => {
  const navermaps = useNavermaps();
  const [center, setCenter] = useState(null);
  const [zoom, setZoom] = useState(13);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!boreholes || boreholes.length === 0 || !navermaps) return;

    // 유효한 좌표를 가진 시추공만 필터링
    const validBoreholes = boreholes.filter(
      b => b.grs80_x && b.grs80_y && !isNaN(b.grs80_x) && !isNaN(b.grs80_y)
    );

    if (validBoreholes.length === 0) return;

    // 모든 시추공이 보이도록 bounds 계산
    const bounds = new navermaps.LatLngBounds();
    validBoreholes.forEach(borehole => {
      bounds.extend(new navermaps.LatLng(borehole.grs80_x, borehole.grs80_y));
    });

    // 중심점 설정
    const centerLatLng = bounds.getCenter();
    setCenter({ lat: centerLatLng.y, lng: centerLatLng.x });

    // 지도가 로드된 후 bounds 맞추기
    if (mapRef.current) {
      setTimeout(() => {
        mapRef.current.fitBounds(bounds, { top: 50, right: 50, bottom: 50, left: 50 });
      }, 100);
    }
  }, [boreholes, navermaps]);

  // 유효한 좌표를 가진 시추공만 필터링
  const validBoreholes = boreholes?.filter(
    b => b.grs80_x && b.grs80_y && !isNaN(b.grs80_x) && !isNaN(b.grs80_y)
  ) || [];

  if (validBoreholes.length === 0) {
    return (
      <div className="bg-white rounded-2xl shadow-soft overflow-hidden mb-8">
        <div className="px-6 py-4 border-b border-secondary-200">
          <h2 className="text-lg font-bold text-secondary-900">시추공 위치</h2>
        </div>
        <div className="h-96 flex items-center justify-center bg-secondary-50">
          <div className="text-center">
            <svg className="w-16 h-16 text-secondary-400 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
            </svg>
            <p className="text-secondary-600">표시할 수 있는 좌표 정보가 없습니다</p>
          </div>
        </div>
      </div>
    );
  }

  if (!center) {
    return (
      <div className="bg-white rounded-2xl shadow-soft overflow-hidden mb-8">
        <div className="px-6 py-4 border-b border-secondary-200">
          <h2 className="text-lg font-bold text-secondary-900">시추공 위치</h2>
        </div>
        <div className="h-96 flex items-center justify-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl shadow-soft overflow-hidden mb-8">
      <div className="px-6 py-4 border-b border-secondary-200 flex items-center justify-between">
        <h2 className="text-lg font-bold text-secondary-900">시추공 위치</h2>
        <span className="text-sm text-secondary-600">
          총 {validBoreholes.length}개 시추공
        </span>
      </div>
      <div className="h-96 relative">
        <MapDiv style={{ width: '100%', height: '100%' }}>
          <NaverMap
            ref={mapRef}
            center={center}
            zoom={zoom}
            onZoomChanged={(newZoom) => setZoom(newZoom)}
            style={{ width: '100%', height: '100%' }}
          >
            {validBoreholes.map((borehole) => (
              <Marker
                key={borehole.id}
                position={{ lat: borehole.grs80_x, lng: borehole.grs80_y }}
                title={borehole.name}
                icon={{
                  content: `
                    <div
                      id="marker-${borehole.id}"
                      style="
                        position: relative;
                        width: 24px;
                        height: 24px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      <!-- 시추공 이름 라벨 (hover 시 표시) -->
                      <div
                        class="marker-label"
                        style="
                          position: absolute;
                          bottom: 32px;
                          left: 50%;
                          transform: translateX(-50%);
                          background: rgba(0,0,0,0.85);
                          color: white;
                          padding: 4px 8px;
                          border-radius: 6px;
                          font-size: 11px;
                          font-weight: 600;
                          white-space: nowrap;
                          box-shadow: 0 2px 6px rgba(0,0,0,0.3);
                          opacity: 0;
                          transition: opacity 0.2s;
                          pointer-events: none;
                          z-index: 1000;
                        "
                      >${borehole.name}</div>

                      <!-- 마커 원형 아이콘 -->
                      <div
                        class="marker-circle"
                        style="
                          width: 24px;
                          height: 24px;
                          background-color: #2780E3;
                          border: 3px solid white;
                          border-radius: 50%;
                          box-shadow: 0 3px 6px rgba(0,0,0,0.5);
                          cursor: pointer;
                          transition: all 0.2s;
                        "
                        onmouseover="
                          this.style.transform = 'scale(1.15)';
                          this.style.boxShadow = '0 4px 12px rgba(39, 128, 227, 0.5)';
                          this.parentElement.querySelector('.marker-label').style.opacity = '1';
                        "
                        onmouseout="
                          this.style.transform = 'scale(1)';
                          this.style.boxShadow = '0 3px 6px rgba(0,0,0,0.5)';
                          this.parentElement.querySelector('.marker-label').style.opacity = '0';
                        "
                      ></div>
                    </div>
                  `,
                  anchor: new navermaps.Point(12, 12),
                }}
                onClick={() => {
                  if (onBoreholeClick) {
                    onBoreholeClick(borehole);
                  }
                }}
              />
            ))}
          </NaverMap>
        </MapDiv>

        {/* 범례 */}
        <div className="absolute bottom-4 right-4 bg-white rounded-lg shadow-medium p-3 z-10">
          <div className="flex items-center space-x-2">
            <div className="w-3 h-3 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 border-2 border-white shadow-sm"></div>
            <span className="text-xs text-secondary-700 font-medium">시추공</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DrillLogMapPreview;
